export const GLOBAL_VENUE_DISCOUNT_PERCENT_KEY = "global-venue-discount-percent"
export const GLOBAL_VENUE_DISCOUNT_DESCRIPTION_KEY = "global-venue-discount-description"